/** What a toast is raised with; only the fields the policy reads are named. */
type ToastOptions = { type?: string; timeout?: number; priority?: 'low' | 'high' };

// An error is read and acted on, so it stays until dismissed; a toast that leaves on its own takes
// the reason with it. Success is a quiet confirmation that goes after a glance.
const ERROR_TOAST = { timeout: 0, priority: 'high' } as const;
const SUCCESS_TOAST = { timeout: 4000, priority: 'low' } as const;

/**
 * The timing and urgency every toast of a type gets, whatever its caller asked for. A caller's
 * longer success timeout stands (an undo needs time to reach its button); nothing shortens an error.
 */
export function applyToastPolicy<TOptions extends ToastOptions>(
  options: TOptions,
): TOptions & ToastOptions {
  if (options.type === 'error') {
    return { ...options, ...ERROR_TOAST };
  }

  if (options.type === 'success') {
    const timeout = Math.max(options.timeout ?? 0, SUCCESS_TOAST.timeout);

    return { ...options, priority: SUCCESS_TOAST.priority, timeout };
  }

  return options;
}
